import { useTranslation } from 'react-i18next';

export function useNumberInputLocalePreset(locale?: string) {
  const { i18n } = useTranslation();

  const localeProps = LOCALE_PRESETS[locale ?? i18n.language];

  return localeProps;
}

type LocalePreset = { thousandSeparator: string; decimalSeparator: string };
type LocalePresets = Record<string, LocalePreset>;

export const LOCALE_PRESETS: LocalePresets = {
  en: { thousandSeparator: ',', decimalSeparator: '.' },
  de: { thousandSeparator: '.', decimalSeparator: ',' },
};
